import { render, staticRenderFns } from "./my-payroll-slip.vue?vue&type=template&id=34c63d50&scoped=true&"
import script from "./my-payroll-slip.vue?vue&type=script&lang=js&"
export * from "./my-payroll-slip.vue?vue&type=script&lang=js&"
import style0 from "./my-payroll-slip.vue?vue&type=style&index=0&id=34c63d50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c63d50",
  null
  
)

export default component.exports